module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/ants.cf98fa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/product/ants.jpg
// module id = 5h1J
// module chunks = 0